var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStress1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.83594L9.49219 8.86719H13.8672C14.375 8.86719 14.8438 9.17969 15.0391 9.64844C15.1953 10.1562 15.0781 10.7031 14.6875 11.0547L4.6875 19.8047C4.21875 20.1562 3.59375 20.1953 3.125 19.8438C2.65625 19.5312 2.46094 18.9062 2.69531 18.3594L5.70312 11.3281H1.36719C0.820312 11.3281 0.351562 11.0156 0.195312 10.5469C0 10.0391 0.117188 9.49219 0.507812 9.14062L10.5078 0.390625C10.9766 0.0390625 11.6016 0 12.0703 0.351562C12.5391 0.664062 12.7344 1.28906 12.5 1.83594Z",
    fill: "#2A8C4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress1);
export default __webpack_public_path__ + "static/media/stress1.f638b6b18f487ed8130174b82e02301f.svg";
export { ForwardRef as ReactComponent };